import { Divider, Grid, Tab, Tabs, Theme, useMediaQuery } from "@material-ui/core";
import React, { useState } from "react";
import { Button, ExportButton, TopToolbar, useDataProvider, useRefresh } from "react-admin";
import { PbhRequestStatus } from "../../Enums/PbhRequestStatus";
import classnames from "classnames";
import { useStyles } from "../RequestOrder/Components/RequestOrderList/styles";
import { useAuth } from "@airborne/react-admin";
import { ExcelExport } from "../../Helper/ExportExcel";
import {
  pbhShippingProcessExportColumn,
  CmsDetailFilterArray,
} from "../RequestOrder/Components/PbhRequestOrderList/pbhRequestList.constants";
import FilterToolbar from "../../Components/FiltersToolbar/FilterToolbar";
import RequestRemark from "../RequestOrder/Components/PbhRequestOrderList/Notes/RequestRemark";
import { RemarkTypes } from "../../Enums/RemarkTypes";
import PoolList from "../../Components/PoolListComponent/PoolListComponent";
import { formatDate } from "../../Helper/MomentHelper";
import CmsDataGrid from "./Cms";

// CMS tab enum
enum CmsTab {
  All = "all",
  ShippingProcess = "shipping_process",
}

const CmsDashboard = props => {
  const [activeTab, setActiveTab] = useState<string>(CmsTab.All);
  const [requestRemark, setRequestRemark] = useState<any>({});
  const [isMatchCreate, setIsMatchCreate] = useState(false);
  const isXSmall = useMediaQuery<Theme>(theme => theme.breakpoints.down("xs"));
  const classes = useStyles();
  const { user } = useAuth();
  const dataProvider = useDataProvider();
  const refresh = useRefresh();

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const getFilterDefaultValues = () => {
    if (activeTab === CmsTab.ShippingProcess) {
      return { requestStatus__eq: PbhRequestStatus.ShippingProcess, "isLocalRepair != true": "test" };
    }
    return { "isLocalRepair != true": "test", requestStatus__neq: PbhRequestStatus.ShippingProcess };
  };

  const ListActions = props => (
    <TopToolbar {...props}>
      <Button
        label="Clear Filters"
        onClick={() => {
          if (activeTab === CmsTab.ShippingProcess) {
            props.setFilters({ requestStatus__eq: PbhRequestStatus.ShippingProcess, "isLocalRepair != true": "test" });
          } else {
            props.setFilters({ "isLocalRepair != true": "test", requestStatus__neq: PbhRequestStatus.ShippingProcess });
          }
        }}
      />
      <ExportButton
        resource={props.resource}
        sort={props.currentSort}
        filterValues={props.filterValues}
        maxResults={10000}
      />
    </TopToolbar>
  );

  const CmsDetailRequestFilter = props => <FilterToolbar dataSource={CmsDetailFilterArray} />;

  const handleCloseRemark = () => {
    refresh();
  };

  const getNotes = async idList => {
    var response = await dataProvider.getList("PbhRequestRemarks", {
      pagination: { page: 1, perPage: 100 },
      sort: { field: "id", order: "ASC" },
      filter: {
        requestId__in: idList,
        remarkType__eq: RemarkTypes.PbhNote,
      },
    });
    return response?.data ?? [];
  };

  const ExportToExcel = async (records, fetchRelatedRecords) => {
    var notesResponse = await getNotes(records.map(x => x.id));
    var columns = [...pbhShippingProcessExportColumn];
    if (user?.isCustomer) columns.pop();
    var data = [
      ...records.map(v => [
        v.refNo,
        v.customerName,
        v.requirementCategoryText,
        v.pn,
        v.pnDescription,
        v.airportCode,
        v.ac,
        formatDate(v.createdDate),
        v.requestedDeliveryDate === null
          ? "Not Arrived Yet"
          : formatDate(v.requestedDeliveryDate, false) == formatDate(new Date("01/01/9999"), false)
            ? "Exclude"
            : formatDate(v.requestedDeliveryDate),
        v.displayWhCount,
        v.displayResCount,
        v.displayAltPnCount,
        v.displayRnCount,
        ...(user?.isCustomer
          ? []
          : [
              notesResponse
                .filter(x => x.requestId == v.id)
                .map(x => x.remark)
                .join(", "),
            ]),
      ]),
    ];
    ExcelExport(columns, data, "CMS Request List");
  };

  return (
    <div style={{ maxWidth: window.innerWidth - window.innerWidth * 0.13, overflow: "auto" }}>
      <Tabs
        style={{ width: "100%" }}
        variant={"fullWidth"}
        centered
        value={activeTab}
        indicatorColor="primary"
        onChange={handleTabChange}
        className={classnames({
          [classes.listWithDrawer]: isMatchCreate,
        })}
      >
        <Tab label="CMS" value={CmsTab.All} />
        {!user?.isCustomer && <Tab label="Shipping Process" value={CmsTab.ShippingProcess} />}
      </Tabs>

      <div style={{ maxWidth: window.innerWidth - window.innerWidth * 0.15, overflow: "auto" }}>
        <Grid container spacing={0}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <PoolList
              {...props}
              key={activeTab}
              id="cms-request-list"
              emptyWhileLoading={true}
              resource={"pbhrequestorders/dashboardcms"}
              basePath={"cmsdashboard"}
              className={classnames(classes.list, { [classes.listWithDrawer]: isMatchCreate })}
              title={"CMS Request Order List"}
              filterDefaultValues={getFilterDefaultValues()}
              actions={<ListActions />}
              sort={{ field: "createdDate", order: "DESC" }}
              exporter={ExportToExcel}
              filters={<CmsDetailRequestFilter />}
              hasCreate={false}
            >
              <CmsDataGrid
                onCreateRemarks={record => {
                  setIsMatchCreate(true);
                  setRequestRemark(record);
                }}
                isXSmall={isXSmall}
                activeTab={activeTab}
              />
            </PoolList>
          </Grid>
        </Grid>
        <Divider />
        <RequestRemark
          isMatchCreate={isMatchCreate}
          setIsMatchCreate={setIsMatchCreate}
          requestRemark={requestRemark}
          handleClose={handleCloseRemark}
        />
      </div>
    </div>
  );
};

export default CmsDashboard;
